var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bx-x"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.4933 5.28711L9.95747 8.82211L6.42247 5.28711L5.24414 6.46544L8.77914 10.0004L5.24414 13.5354L6.42247 14.7138L9.95747 11.1788L13.4933 14.7138L14.6716 13.5354L11.1366 10.0004L14.6716 6.46544L13.4933 5.28711Z",
    fill: "#6B7280"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/Cross.e6cd1ad683502ff15edfa2ffee82fc21.svg";
export { ForwardRef as ReactComponent };